const OwnerDashboardNavbar = (props) => {
  const { isExpanded, setIsExpanded, activeMenu, setActiveMenu } = props;
  const menuItems = [
    { id: "general", label: "General", icon: "pi pi-user" },
    { id: "customer", label: "Customer", icon: "pi pi-users" },
    { id: "employee", label: "Employee", icon: "pi pi-user" },
  ];

  const toggleNavbar = () => {
    setIsExpanded(!isExpanded);
  };

  const handleMenuClick = (menuId) => {
    setActiveMenu(menuId);
  };
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="relative">
        {/* Menu Items */}
        <div
          className={`absolute bottom-20 right-0 flex flex-col-reverse items-end gap-4 transition-all duration-300 ease-in-out ${
            isExpanded
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          }`}
        >
          {menuItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-3 transform transition-all duration-300 ease-out ${
                isExpanded
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-4"
              }`}
              style={{
                transitionDelay: isExpanded
                  ? `${index * 100}ms`
                  : `${(menuItems.length - index) * 50}ms`,
              }}
            >
              {/* Text label */}
              <span className="flex flex-row items-center justify-start px-3 py-1 rounded-lg shadow-xl text-sm font-medium bg-slate-100 text-black font-semibold">
                {activeMenu === item.id && (
                  <i className="bg-gradient-to-br from-green-400 to-emerald-500 bg-clip-text text-transparent pi pi-circle-fill text-xs mr-2"></i>
                )}
                {item.label}
              </span>

              {/* Icon button */}
              <button
                onClick={() => handleMenuClick(item.id)}
                className={`w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center rounded-full transition-all duration-200 group backdrop-blur-md shadow-xl bg-gradient-to-b from-blue-500 to-indigo-500 ${
                  activeMenu === item.id
                    ? "bg-white/20 text-white"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
                title={item.label}
              >
                <i className={`${item.icon} text-2xl`} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Toggle Button */}
      <button
        onClick={toggleNavbar}
        className="absolute bottom-0 right-0 bg-gradient-to-b from-blue-500 to-indigo-500 w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center text-white hover:bg-white/10 rounded-full transition-colors duration-200 shadow-lg"
      >
        <i
          className={`pi text-xl transition-transform duration-300 ${
            isExpanded ? "pi pi-chevron-down" : "pi-ellipsis-v"
          }`}
        />
      </button>
    </div>
  );
};

export default OwnerDashboardNavbar;
